import { PageHero } from "@/components/site/PageHero";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { Check } from "lucide-react";
import { SERVICE_GROUPS } from "@/data/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        label="Services"
        titleLines={["End-to-end", "urban", "solutions"]}
        intro="From planning and DPRs to digital governance, smart collection, and scientific processing — five verticals delivered under one accountable ecosystem."
        testId="services-hero"
      />

      {SERVICE_GROUPS.map((group, gi) => (
        <section
          key={group.id}
          data-testid={`service-group-${group.id}`}
          className={`px-5 md:px-10 py-20 md:py-28 border-b border-raritan-border ${gi % 2 === 1 ? "bg-raritan-green-soft" : ""}`}
        >
          <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <span className="font-heading font-black text-6xl md:text-8xl text-raritan-red/20 leading-none">{group.tag}</span>
                <SectionLabel className="mt-4 mb-4">{group.lead}</SectionLabel>
                <h2 className="font-heading font-black uppercase tracking-tighter text-3xl md:text-5xl text-raritan-ink leading-[0.95]">{group.title}</h2>
                <p className="mt-5 font-body text-raritan-muted leading-relaxed">{group.desc}</p>
              </div>
            </div>
            <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-raritan-border border border-raritan-border self-start">
              {group.items.map((item, i) => (
                <Reveal key={item.name} delay={i * 0.05}>
                  <div className="bg-raritan-surface p-6 md:p-7 h-full">
                    <h3 className="font-heading font-bold text-lg text-raritan-ink border-b border-raritan-border pb-3">{item.name}</h3>
                    <ul className="mt-4 space-y-2.5">
                      {item.points.map((p) => (
                        <li key={p} className="flex gap-2.5 font-body text-sm text-raritan-muted">
                          <Check size={16} className="text-raritan-green shrink-0 mt-0.5" />
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
